import { Button, Modal, message } from "antd";
import PreBookingInfoHorizontal from "./components/PreBookingInfoHorizontal";
import GuestInfoForm from "./components/GuestInfoForm";
import { Container, Row, Col, Hidden } from "react-grid-system";
import { LeftOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { usePrebookingRequest } from "../data/PrebookingRequest";
import axios from "axios";
import { useState } from "react";

interface ConfirmationProps {
    messageApi: ReturnType<typeof message.useMessage>[0];
}

function Confirmation(props: ConfirmationProps) {
    const navigate = useNavigate();
    const prebookingRequest = usePrebookingRequest(state => state.prebooking);
    const getTrimmed = usePrebookingRequest(state => state.getTrimmed);
    const infoProvided = usePrebookingRequest(state => state.prebooking?.infoProvided);
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

    function handleConfirm() {
        if (buttonDisabled) return;
        setButtonDisabled(true);
        props.messageApi.loading("Buchung wird abgesendet...", 0,);
        axios.post(`wp-json/tts-booking/v1/events/book`, getTrimmed(prebookingRequest!))
            .then((res) => {
                props.messageApi.destroy();
                props.messageApi.success("Booking successful!");
                navigate("/success");
            }).catch((err) => {
                props.messageApi.destroy();
                if (err.response.status === 418) {
                    Modal.error({
                        title: "Could not verify WSDC discount!",
                        content: "Please check your (and your partners, if applicable) WSDC ID, as well as your first and last name, and try again."
                    })
                } else {
                    props.messageApi.error("Booking failed! " + err.response.data.message);
                }
                setButtonDisabled(false);
            });
    }

    return (
        <Container>
            <h1 style={{ textAlign: "left", color: "black", fontSize: "3rem", marginBottom: "0px", lineHeight: "3rem" }}>Complete booking</h1>
            <Row style={{ textAlign: "left" }} gutterWidth={20}>
                <Col md={8} style={{ marginTop: "20px" }}>
                    <div style={{
                        backgroundColor: "white", borderRadius: "10px", padding: "20px", minHeight: "500px",
                        boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)"
                    }}>
                        <h2 style={{ marginTop: 0, marginBottom: 0, color: "black" }}>Your selection</h2>
                        <p style={{ marginTop: 0 }}>Here you can review your selection once again. If you want to make any changes, click on 'Back'.</p>
                        <PreBookingInfoHorizontal />
                    </div>
                </Col>
                <Col md={4} style={{ marginTop: "20px" }}>
                    <div style={{
                        backgroundColor: "white", borderRadius: "10px", padding: "20px", minHeight: "500px", paddingBottom: "20px",
                        boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)"
                    }}>
                        <h2 style={{ marginTop: 0, marginBottom: 0, color: "black" }}>Billing address</h2>
                        <p style={{ margin: 0 }}>Please provide your billing address.</p>
                        <GuestInfoForm messageApi={props.messageApi} />
                    </div>
                </Col>
            </Row>
            <Row style={{ marginTop: "20px" }} gutterWidth={20}>
                <Hidden xs>
                    <Col xl={12} style={{ marginTop: "20px", clear: "both" }}>
                        <Button size="large" type="primary" onClick={() => navigate(-1)} style={{ float: "left" }}><LeftOutlined />Back</Button>
                        <Button size="large" type="primary" disabled={(!infoProvided) || buttonDisabled} onClick={() => handleConfirm()} style={{ float: "right" }}>Complete booking <CheckCircleOutlined /></Button>
                    </Col>
                </Hidden>
                <Hidden sm md lg xl xxl xxxl>
                    <Col xl={12} style={{ marginTop: "20px", clear: "both" }}>
                        <Button size="middle" type="primary" onClick={() => navigate(-1)} style={{ float: "left" }}><LeftOutlined />Back</Button>
                        <Button size="middle" type="primary" disabled={(!infoProvided) || buttonDisabled} onClick={() => handleConfirm()} style={{ float: "right" }}>Complete booking <CheckCircleOutlined /></Button>
                    </Col>
                </Hidden>
            </Row>
        </Container>
    )
}

export default Confirmation;